function ShowRadiusAddressResults() {
    $.DotComAjax({
        url: "/Ajax/GetRadiusAroundAddressResults",
        cache: false,
        dataType: 'html',
        success: function (data) {
            BuildRadiusAddressResults(data);
        },
        async: true,
        type: 'post',
        data: $('#RadiusControl').serialize()
    });
}

function BuildRadiusAddressResults(data) {
    $('#divRadiusAroundAddressResults').html('');
    $('#divRadiusAroundAddressResults').append(data);
}
